import PropTypes from 'prop-types';
// material
import { Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
  color: PropTypes.string,
  height: PropTypes.number
};

export default function Logo({ sx, color, height = 40 }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.dark;
  const PRIMARY_MAIN = theme.palette.primary.main;

  function getColor(color) {
    if (color === 'white') return '#FFF';
    if (color === 'dark') return PRIMARY_MAIN;
    return PRIMARY_LIGHT;
  }

  return (
    <Box sx={{ ...sx, display: 'flex', justifyContent: 'center' }}>
      <Box
        component="img"
        src="/static/hub-crea/LOGO-HUB-CREA-HORIZONTAL-FINAL-16.png"
        sx={{ height, mb: '0.313rem' }}
      />
    </Box>
  );
}
